import { render } from "./ExternalProductDetailsPage.vue?vue&type=template&id=51bbcfb4"
import script from "./ExternalProductDetailsPage.vue?vue&type=script&lang=js"
export * from "./ExternalProductDetailsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__